<template>

<app-content-box class="renewal" :class="{'is-cancelled': !isActive}" :not-padded="true">

	<div class="renewal-day">{{ subscription.date.renew | localDate('Do')}}</div>
	<div class="renewal-month">{{ subscription.date.renew | localDate('MMMM')}}</div>
	<div class="renewal-label" v-if="isActive">Your next renewal</div>
	<div class="renewal-label" v-if="isExpiring">Membership ends on</div>
	<div class="renewal-label" v-if="isCancelled">Membership ended on</div>

</app-content-box>

</template>

<script>

export default {

	props: ['subscription'],

    computed: {
    
        isActive: function() {
		
			return this.subscription.status === 1
		
		},

		isCancelled: function() {
		
			return this.subscription.status === 2
		
		},

		isExpiring: function() {
		
			return this.subscription.status === 3
		
		}

    }

}

</script>

<style scoped>

.renewal {
    min-height: 240px;
}

.renewal >>> .box-content {
    height: 100%;
	color: #4082d3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
}

.renewal-day {
    font-size: 64px;
    font-weight: 500;
    margin-top: -40px;
}

.renewal-month {
    font-size: 16px;
    font-weight: 300;
    margin-top: 5px;
}

.renewal-label {
    border-top: 1px solid #eee;
    padding: 20px;
    position: absolute;
    color: #343434;
    left: 0px;
    text-align: center;
    font-weight: 500;
    width: 100%;
    bottom: 0px;
}

.renewal.is-cancelled >>> .box-content {
	background-color: #c55b5b;
    color: #fff;
}

.renewal.is-cancelled .renewal-label {
    color: #fff;
}

</style>
